<div>
    <ngx-spinner bdColor="rgba(206,58,6,0.8)" size="medium" color="#fff" type="ball-newton-cradle" [fullScreen]="true">
        <p *ngIf="!show" style="color: white !important; padding-top: 1vw;"> Loading... </p>
        <p *ngIf="show" style="color: white !important; padding-top: 1vw;"> Enviado Correctamente... </p>
    </ngx-spinner>
</div>

<div class="container">

    <h1 style="display: none;">Triidy</h1>
    <!--FILA COMERCIO ELECTRONICO-->

    <div class="row animate__animated animate__fadeIn">
        <!--MOVIL-->
        <div class="col cimg-1-mov movcom">
            <img class="img-1" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/principal2.svg" alt="">
        </div>
        <!--NAVEGADOR-->
        <div class="col prin-col">
            <h2>Creamos conexiones de <span class="triidy-color">alto valor para tu ecommerce</span></h2>
            <p>
                Más de 10.000 comercios electrónicos procesan sus ventas con nosotros, optimizando sus operaciones logísticas. Integrando su sitio web, accediendo a proveedores de productos y gestionando envíos
            </p>
            <!--<div class="cont-btn">
                <input routerLink="/registro-comercio" class="btn pulse" type="button" value="Registrate">
            </div>-->
            <div class="cont-btn">
                <a class="btn pulse wind" href="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy.rar">Descargar app<i
                        class="fas fa-cloud-download-alt"></i></a>
                <a class="btn pulse app" href="market://search?q=triidy">Descargar app<i
                        class="fas fa-cloud-download-alt"></i></a>
            </div>
        </div>
        <div class="col cimg-1 navcom">
            <img class="img-1" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/principal2.svg" alt="">
        </div>
    </div>

    <!--FILA PLATAFORMA ACELERADORA-->
    <div class="row light-grey">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="100%" height="130" viewBox="0 0 130 130" class="sep3">
            <polyline _ngcontent-cax-c114="" points="-810,85 65,110 945,85" fill="none" stroke-width="2"
                stroke="#f58b1f" stroke-linejoin="round"></polyline>
        </svg>
    </div>
    <div class="row" data-aos="fade-up">
        <div class="col cpre-2">
            <div id="preloader_3"></div>
        </div>
        <div class="col-7">
            <h2>Somos una <span class="triidy-color">plataforma digital</span> de comercio electrónico</h2>
            <p>Conectamos procesos claves para un ecommerce, como la gestión logística, la visibilidad financiera y la administración de productos. Logramos que tus costos operativos se reduzcan hasta en un 40%, automatizando procesos logísticos a partir
                de la toma de pedidos desde tu sitio web hasta la visualización completa de envíos en tiempo real
            </p>
            <!--<div class="cont-btn">
                <a class="btn pulse wind" href="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy.rar">Descargar app<i
                        class="fas fa-cloud-download-alt"></i></a>
                <a class="btn pulse app" href="market://search?q=triidy">Descargar app<i
                        class="fas fa-cloud-download-alt"></i></a>
            </div>-->
            <div class="cont-btn">
                <input routerLink="/registro-comercio" class="btn pulse" type="button" value="Registrate">
            </div>
        </div>
        <div class="col cpre-2">
            <div id="preloader_3"></div>
        </div>
    </div>

    <!--FILA SERVICIOS-->
    <div class="row light-grey" id="servicios" name="servicios">
        <!--<svg id="" preserveAspectRatio="xMidYMax meet" class="svg-separator sep2" viewBox="0 0 1600 200" style="display: block;" data-height="200">
            <polygon class="" style="opacity: 1; fill: #f58b1f;" points="2604,198 2604,186 -4,0 -4,0 	"></polygon>
            <polygon class="" style="opacity: 1; fill: #ee3e30;" points="2604,186 2604,174 -4,0 -4,0 	"></polygon>
        </svg>-->
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="100%" height="130" viewBox="0 0 130 130" class="sep3">
            <polyline _ngcontent-cax-c114="" points="-810,85 65,110 945,85" fill="none" stroke-width="2"
                stroke="#f58b1f" stroke-linejoin="round"></polyline>
        </svg>
    </div>
    <div class="service-f mr" data-aos="fade-up">
        <h2><span class="triidy-color">Servicios</span></h2>
        <p>
            Entendemos que tu negocio no es como los demás, por eso nuestra metodología de innovación continua integra servicios que se acoplan a tus necesidades
        </p>
    </div>
    <section class="hero-section" data-aos="fade-up">
        <div class="card-grid">
            <a class="card">
                <div class="card__background card_prod">
                </div>
                <div class="card__content">
                    <div class="card__row r-t">
                        <h3 class="card__heading">Producto</h3>
                    </div>
                    <div class="card__row r-c">
                        <p class="card__category">Carga tus inventarios, conecta un proveedor propio o accede a los proveedores más calificados del país y vende sus productos</p>
                    </div>
                    <div class="card__row r-b">
                        <a class="card__btn" routerLink="/servicios">
                            <svg class="icon-arrow before">
                                <use xlink:href="#arrow"></use>
                            </svg>
                            <span class="label">Ver mas</span>
                            <svg class="icon-arrow after">
                                <use xlink:href="#arrow"></use>
                            </svg>
                        </a>

                        <svg style="display: none;">
                            <defs>
                                <symbol id="arrow" viewBox="0 0 35 15">
                                    <title>Arrow</title>
                                    <path
                                        d="M27.172 5L25 2.828 27.828 0 34.9 7.071l-7.07 7.071L25 11.314 27.314 9H0V5h27.172z " />
                                </symbol>
                            </defs>
                        </svg>
                    </div>
                </div>
            </a>
            <!--<a class="card">
                <div class="card__background card_merc">
                </div>
                <div class="card__content">
                    <div class="card__row r-t">
                        <h3 class="card__heading">Mercadeo</h3>
                    </div>
                    <div class="card__row r-c">
                        <p class="card__category">Gestiona tus clientes y crea estrategias de marketing con nuestra plataforma
                        </p>
                    </div>
                    <div class="card__row r-b">
                        <a class="card__btn" routerLink="/servicios">
                            <svg class="icon-arrow before">
                                <use xlink:href="#arrow"></use>
                            </svg>
                            <span class="label">Ver mas</span>
                            <svg class="icon-arrow after">
                                <use xlink:href="#arrow"></use>
                            </svg>
                        </a>

                        <svg style="display: none;">
                            <defs>
                                <symbol id="arrow" viewBox="0 0 35 15">
                                    <title>Arrow</title>
                                    <path
                                        d="M27.172 5L25 2.828 27.828 0 34.9 7.071l-7.07 7.071L25 11.314 27.314 9H0V5h27.172z " />
                                </symbol>
                            </defs>
                        </svg>
                    </div>
                </div>
            </a>-->
            <a class="card">
                <div class="card__background card_log">
                </div>
                <div class="card__content">
                    <div class="card__row r-t">
                        <h3 class="card__heading">Logistica</h3>
                    </div>
                    <div class="card__row r-c">
                        <p class="card__category">Integra tu equipo de trabajo,conecta proveedores y envía tus productos a más de 1.000 municipios en el país, 300 de ellos con servicio a contra-entrega</p>
                    </div>
                    <div class="card__row r-b">
                        <a class="card__btn" routerLink="/servicios">
                            <svg class="icon-arrow before">
                                <use xlink:href="#arrow"></use>
                            </svg>
                            <span class="label">Ver mas</span>
                            <svg class="icon-arrow after">
                                <use xlink:href="#arrow"></use>
                            </svg>
                        </a>

                        <svg style="display: none;">
                            <defs>
                                <symbol id="arrow" viewBox="0 0 35 15">
                                    <title>Arrow</title>
                                    <path
                                        d="M27.172 5L25 2.828 27.828 0 34.9 7.071l-7.07 7.071L25 11.314 27.314 9H0V5h27.172z " />
                                </symbol>
                            </defs>
                        </svg>
                    </div>

                </div>
            </a>
            <a class="card c-fin">
                <div class="card__background card_fin">
                </div>
                <div class="card__content">
                    <div class="card__row r-t">
                        <h3 class="card__heading">Finanzas</h3>
                    </div>
                    <div class="card__row r-c">
                        <p class="card__category">Optimiza el manejo de tus recursos financieros para el logro de objetivos e incrementar la rentabilidad</p>
                    </div>
                    <div class="card__row r-b">
                        <a class="card__btn" routerLink="/servicios">
                            <svg class="icon-arrow before">
                                <use xlink:href="#arrow"></use>
                            </svg>
                            <span class="label">Ver mas</span>
                            <svg class="icon-arrow after">
                                <use xlink:href="#arrow"></use>
                            </svg>
                        </a>

                        <svg style="display: none;">
                            <defs>
                                <symbol id="arrow" viewBox="0 0 35 15">
                                    <title>Arrow</title>
                                    <path
                                        d="M27.172 5L25 2.828 27.828 0 34.9 7.071l-7.07 7.071L25 11.314 27.314 9H0V5h27.172z " />
                                </symbol>
                            </defs>
                        </svg>
                    </div>
                </div>
            </a>
        </div>
    </section>

    <!--FILA ALIADOS-->
    <div class="row light-grey">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="100%" height="130" viewBox="0 0 130 130" class="sep3">
            <polyline _ngcontent-cax-c114="" points="-810,85 65,110 945,85" fill="none" stroke-width="2"
                stroke="#f58b1f" stroke-linejoin="round"></polyline>
        </svg>
    </div>
    <div class="row" data-aos="fade-up">
        <div class="col-5">
            <h2>Confiamos en nuestros aliados</h2>
        </div>
        <!--<div class="col ali-im">
            <img class="img-ali" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/ali-crecel.jpg" alt="">
        </div>
        <div class="col ali-im">
            <img class="img-ali" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/ali-verde.png" alt="">
        </div>
        <div class="col ali-im">
            <img class="img-ali" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/ali-branding.png" alt="">
        </div>
        <div class="col ali-im">
            <img class="img-ali" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/ali-ndc.png" alt="">
        </div>-->
        <div class="col-6">
            <div class="slider">
                <div class="slide-track">
                    <div class="slide">
                        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/ali-crecel.jpg" height="100" width="250" alt="" />
                    </div>
                    <div class="slide">
                        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/ali-verde.png" height="100" width="250" alt="" />
                    </div>
                    <div class="slide">
                        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/ali-branding.png" height="100" width="250" alt="" />
                    </div>
                    <div class="slide">
                        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/ali-ndc.png" height="100" width="250" alt="" />
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!--BENEFICIOS-->
    <div class="row light-grey">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="100%" height="130" viewBox="0 0 130 130" class="sep3">
            <polyline _ngcontent-cax-c114="" points="-810,85 65,110 945,85" fill="none" stroke-width="2"
                stroke="#f58b1f" stroke-linejoin="round"></polyline>
        </svg>
    </div>
    <div class="row ben-tit" data-aos="fade-up">
        <h2><span class="triidy-color">Mejores ventas para tu ecommerce</span></h2>
        <hr>
        <h3><span class="subt-ben">Beneficios</span></h3>
    </div>
    <div class="row ben-cont" data-aos="fade-up">
        <div class="ben-fond"></div>
        <div class="row">
            <div class="col">
                <h3>1. Seguridad de Datos</h3>
                <p>La privacidad de tu información esta en buenas manos, contamos con tecnología robusta que garantiza la seguridad de la información sensible y preserva la integridad de datos personales, financieros y de clientes</p>
            </div>
            <div class="col">
                <h3>2. Soporte</h3>
                <p>El equipo de soporte tiene como enfoque asegurar la continuidad operacional del comercio, ayudando a que los comercios aumenten la productividad de su equipo de trabajo</p>
            </div>
            <div class="col">
                <h3>3. Billetera Virtual</h3>
                <p>Es una herramienta financiera para la administración del dinero de tu comercio, en donde puedes comprar productos a proveedores, recaudar el dinero de las ventas, solicitar créditos y pagar envíos
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <h3>4. Optimizamos las entregas</h3>
                <p>Brindamos visibilidad de las ciudades y sectores donde tienes un flujo de ventas más alto, para que conectes tus productos con nuestro sistema de bodegas inteligentes y mensajeros de última milla, logrando que las entregas pasen de 3 días
                    a 12 horas
                </p>
            </div>
            <div class="col">
                <h3>5. Geolocalización</h3>
                <p>Nos encargamos de que tus clientes siempre estarán informados sobre dónde están sus paquetes en tiempo real, por medio de sms, correos electrónicos y nuestro sitio web, garantizando la transparencia de las entregas</p>
            </div>
            <div class="col">
                <h3>6. Triidy Boost</h3>
                <p>La herramienta digital de Boost, analiza los datos de tu comercio, como producto, logística, finanzas y marketing, brindando sugerencias y pasos a seguir para llevar tu negocio al siguiente nivel</p>
            </div>
        </div>
    </div>

    <!--NUESTROS CLIENTES-->
    <div class="row light-grey">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="100%" height="130" viewBox="0 0 130 130" class="sep3">
            <polyline _ngcontent-cax-c114="" points="-810,85 65,110 945,85" fill="none" stroke-width="2"
                stroke="#f58b1f" stroke-linejoin="round"></polyline>
        </svg>
    </div>
    <div class="cli-fon" data-aos="fade-up">
        <div class="cli-f mr">
            <h2>Nuestros Clientes</h2>
            <p>
                El comercio electrónico debe estar al alcance de todos, por eso en Triidy <br> desarrollamos herramientas digitales que se adaptan <br> a las necesidades de nuestros clientes
            </p>
        </div>
        <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div class="blockquote-wrapper">
                        <div class="blockquote">
                            <h1>
                                “Con el servicio de <span class="triidy-color">Dropshipping</span>, hemos podido distribuir nuestros productos a más de 500 tiendas virtuales, las cuales realizan envios en todo el país, todo a través de la plataforma Triidy”
                            </h1>
                            <h4>&mdash;Crecel<br><em>Proveedor</em></h4>
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="blockquote-wrapper">
                        <div class="blockquote">
                            <h1>
                                “Gracias a Triidy hemos podido <span class="triidy-color">crecer exponencialmente
                                </span>, con más de 70.000 seguidores en instagram y poco mas de 2000 ventas al mes”
                            </h1>
                            <h4>&mdash;Yadel Arroyave<br><em>Quegangazo</em></h4>
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="blockquote-wrapper">
                        <div class="blockquote">
                            <h1>
                                “Como Líder de tiendas, es importante que estén conectadas, a un <span class="triidy-color">sistema integral con acceso a servicios de producto, finanzas
                                    y
                                    logística</span>”
                            </h1>
                            <h4>&mdash;Johan<br><em>Líder</em></h4>
                        </div>
                    </div>
                </div>
            </div>
            <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>

    <!--CONTACTANOS-->
    <div class="row light-grey">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="100%" height="130" viewBox="0 0 130 130" class="sep3">
            <polyline _ngcontent-cax-c114="" points="-810,85 65,110 945,85" fill="none" stroke-width="2"
                stroke="#f58b1f" stroke-linejoin="round"></polyline>
        </svg>
    </div>
    <div class="row" data-aos="fade-up">
        <div class="col cimg-5">
            <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Gif-Contacto.gif" alt="">
        </div>
        <div class="col">
            <h2><span class="triidy-color">Contactános</span></h2>
            <p>
                Si necesitas mas información o asesoría ponte en contacto con nosotros
                <br>
                <!--<a href="mailto:comercial@triidy.com"><span class="triidy-color">comercial@triidy.com</span></a>-->
            </p>
            <div class="cont-btn">
                <form [formGroup]="profileForm" (ngSubmit)="sendMail()">
                    <div class="form__group field">
                        <input type="name" class="form__field" placeholder="" name="nombre" id='nombre' formControlName="nombre" autocomplete="off" required />
                        <label for=" nombre " class="form__label ">Nombre Completo</label>
                        <mat-error *ngIf="(registerFormControl.nombre.touched) && (registerFormControl.nombre.errors?.required) ">
                            Falta el Nombre</mat-error>
                        <mat-error *ngIf="(registerFormControl.nombre.errors?.minLength || registerFormControl.nombre.errors?.maxLength) ">
                            Nombre Completo, Por favor!</mat-error>
                    </div>
                    <div class="form__group field">
                        <input type="company" class="form__field" placeholder="" name="empresa" id='empresa' formControlName="empresa" autocomplete="off" required />
                        <label for=" empresa " class="form__label ">Nombre Empresa</label>
                        <mat-error *ngIf="(registerFormControl.empresa.touched) && (registerFormControl.empresa.errors?.required) ">
                            Falta el Nombre</mat-error>
                        <mat-error *ngIf="(registerFormControl.empresa.errors?.minLength || registerFormControl.empresa.errors?.maxLength) ">
                            Nombre Completo, Por favor!</mat-error>
                    </div>
                    <div class="form__group field">
                        <input type="email" class="form__field" placeholder="" name="correo " id='correo' formControlName="correo" autocomplete="off" required />
                        <label for=" correo" class="form__label">Correo </label>
                        <mat-error *ngIf="(registerFormControl.correo.touched) && (registerFormControl.correo.errors?.required)">
                            Falta el Correo
                        </mat-error>
                        <mat-error *ngIf="registerFormControl.correo.errors?.email">
                            No es el formato de un correo
                        </mat-error>
                    </div>
                    <div class="form__group field">
                        <input type="number" class="form__field" placeholder="" name="celular" id='celular' formControlName="celular" autocomplete="off" required />
                        <label for=" celular" class="form__label">Celular </label>
                        <mat-error *ngIf="(registerFormControl.celular.touched) && (registerFormControl.celular.errors?.required) ">
                            Falta el Celular</mat-error>
                        <mat-error *ngIf="(registerFormControl.celular.errors?.min || registerFormControl.celular.errors?.max) ">
                            No es un numero de celular</mat-error>
                    </div>
                    <div class="form__group field">
                        <textarea class="form__field" rows="4" cols="50" placeholder="Message..." name="mensaje " id="mensaje" formControlName="mensaje" required></textarea>
                        <label for="mensaje" class="form__label">Mensaje</label>
                        <mat-error *ngIf="(registerFormControl.mensaje.touched) && registerFormControl.mensaje.errors?.required">
                            Mensaje incorrecto</mat-error>
                    </div>
                    <div class="form_sub">
                        <input class="btn raise" type="submit" value="Enviar">
                    </div>
                </form>
            </div>
        </div>
    </div>

    <!--COSTOS-->
    <div class="row cost-row" data-aos="zoom-in">
        <h2>Sin costos fijos mensuales</h2>
        <div class="row cost-btn">
            <a class="btn pulse" routerLink="/registro-comercio">Empieza a vender </a>
        </div>
    </div>
</div>